module.exports = __webpack_public_path__ + "assets/img/NVIDIA-a269c63c.png";